import { useEffect, useRef, useState, useCallback } from 'react';
import { useUpdateCollaborationParentState } from '../../hooks/useCollaborationParentState';
const getParentPathname = () => {
  try {
    var _window$parent$locati;
    return (_window$parent$locati = window.parent.location) === null || _window$parent$locati === void 0 ? void 0 : _window$parent$locati.pathname;
  } catch (___error) {
    return '';
  }
};
const safeParentAddEventListener = (type, listener) => {
  try {
    window.parent.addEventListener(type, listener);
  } catch (___error) {
    // Do nothing
  }
};
const safeParentRemoveEventListener = (type, listener) => {
  try {
    window.parent.removeEventListener(type, listener);
  } catch (___error) {
    // Do nothing
  }
};
export const useOnParentPathnameChange = (...calls) => {
  const pathNameRef = useRef(getParentPathname());
  const {
    resetParentAppState
  } = useUpdateCollaborationParentState();
  useEffect(() => {
    const handleLocationChange = () => {
      const newPathName = getParentPathname();
      if (newPathName !== pathNameRef.current) {
        pathNameRef.current = newPathName;
        calls.forEach(call => call(newPathName));
        resetParentAppState();
      }
    };
    // Listen for navigation events in parent window
    safeParentAddEventListener('popstate', handleLocationChange);
    // Listen for programmatic history changes
    safeParentAddEventListener('pushstate', handleLocationChange);
    safeParentAddEventListener('replacestate', handleLocationChange);
    return () => {
      safeParentRemoveEventListener('popstate', handleLocationChange);
      safeParentRemoveEventListener('pushstate', handleLocationChange);
      safeParentRemoveEventListener('replacestate', handleLocationChange);
    };
  }, [calls, resetParentAppState]);
};
const disabledPathsRegex = [new RegExp('/breeze-studio/\\d+/agent-builder/chat-agents')];
const getIsDisabledPath = pathname => {
  return disabledPathsRegex.some(regex => regex.test(pathname));
};
export const useIsDisabledPath = () => {
  const [isPathDisabled, setIsPathDisabled] = useState(getIsDisabledPath(getParentPathname()));
  const handlePathnameChange = useCallback(p => setIsPathDisabled(getIsDisabledPath(p)), []);
  useOnParentPathnameChange(handlePathnameChange);
  return isPathDisabled;
};